import { render, staticRenderFns } from "./DoctorScheduleCalendar.vue?vue&type=template&id=198a7358&scoped=true"
import script from "./DoctorScheduleCalendar.vue?vue&type=script&lang=js"
export * from "./DoctorScheduleCalendar.vue?vue&type=script&lang=js"
import style0 from "./DoctorScheduleCalendar.vue?vue&type=style&index=0&id=198a7358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a7358",
  null
  
)

export default component.exports